// Web-exclusive Step: Job Type Selection
// Phase 4: First step of job posting wizard

import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { Clock, Calendar, Globe, CalendarDays, FileText, Check } from 'lucide-react';
import { webColors, webBorderRadius } from '../../../constants/webStyles';

const JOB_TYPES = [
  {
    id: 'locum',
    title: 'Locum',
    Icon: Clock,
    iconBg: '#dbeafe',
    iconColor: '#2563eb',
    description: 'Short-term or ad hoc roles to fill in for absent staff or cover immediate needs. Can range from single to multiple shifts.',
  },
  {
    id: 'fulltime',
    title: 'Full-Time',
    Icon: Calendar,
    iconBg: '#dcfce7',
    iconColor: '#16a34a',
    description: 'Ongoing employment with a healthcare facility, considered permanent or long-term employment.',
  },
  {
    id: 'international',
    title: 'International',
    Icon: Globe,
    iconBg: '#fee2e2',
    iconColor: '#dc2626',
    description: 'Job opportunities in countries outside of your current location. Includes positions requiring relocation.',
  },
  {
    id: 'temporary',
    title: 'Temporary',
    Icon: CalendarDays,
    iconBg: '#fef3c7',
    iconColor: '#d97706',
    description: 'Non-permanent roles with a fixed duration, typically planned in advance.',
  },
  {
    id: 'contract',
    title: 'Contract',
    Icon: FileText,
    iconBg: '#f3e8ff',
    iconColor: '#9333ea',
    description: 'Fixed-duration roles with a formal agreement outlining start and end dates.',
  },
];

const StepJobType = ({ formData, updateFormData }) => {
  const selectJobType = (type) => {
    updateFormData('jobType', type);
  };

  return (
    <View style={styles.container}>
      {JOB_TYPES.map((type) => (
        <TouchableOpacity
          key={type.id}
          style={[
            styles.jobTypeOption,
            formData.jobType === type.id && styles.jobTypeOptionSelected,
          ]}
          onPress={() => selectJobType(type.id)}
          activeOpacity={0.7}
        >
          <View style={styles.optionHeader}>
            <View style={[styles.optionIcon, { backgroundColor: type.iconBg }]}>
              <type.Icon size={18} color={type.iconColor} />
            </View>
            <Text style={styles.optionTitle}>{type.title}</Text>
            {formData.jobType === type.id && (
              <View style={styles.checkmark}>
                <Check size={14} color="#ffffff" />
              </View>
            )}
          </View>
          <Text style={styles.optionDesc}>{type.description}</Text>
        </TouchableOpacity>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    gap: 12,
  },
  jobTypeOption: {
    padding: 16,
    paddingHorizontal: 20,
    backgroundColor: webColors.backgroundAlt,
    borderWidth: 2,
    borderColor: webColors.border,
    borderRadius: webBorderRadius.medium,
  },
  jobTypeOptionSelected: {
    borderColor: webColors.primary,
    backgroundColor: webColors.primaryLight,
  },
  optionHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    marginBottom: 6,
  },
  optionIcon: {
    width: 36,
    height: 36,
    borderRadius: webBorderRadius.medium,
    alignItems: 'center',
    justifyContent: 'center',
  },
  optionTitle: {
    flex: 1,
    fontSize: 16,
    fontWeight: '600',
    color: webColors.textPrimary,
  },
  checkmark: {
    width: 24,
    height: 24,
    borderRadius: 12,
    backgroundColor: webColors.primary,
    alignItems: 'center',
    justifyContent: 'center',
  },
  optionDesc: {
    fontSize: 13,
    color: webColors.textMuted,
    lineHeight: 18,
    marginLeft: 48,
  },
});

export default StepJobType;
